import React, {useContext} from "react";
import {Fade} from "react-reveal";
import emoji from "react-easy-emoji";
import "./Greeting.scss";
import landingPerson from "../../assets/lottie/landingPerson";
import DisplayLottie from "../../components/displayLottie/DisplayLottie";
import DrOmarKhanPic from "../../components/displayLottie/DrOmarKhanPic.js";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import Button from "../../components/button/Button";

import {illustration, greeting} from "../../portfolio";
import StyleContext from "../../contexts/StyleContext";

export default function Greeting() {
  const {isDark} = useContext(StyleContext);
  if (!greeting.displayGreeting) {
    return null;
  }
  return (
    <Fade bottom duration={1000} distance="40px">
      <div className="greet-main" id="greeting">
        <div className="greeting-main">
          <div className="greeting-text-div">
            <div>
              <h1
                className={isDark ? "dark-mode greeting-text" : "greeting-text"}
              >
                {" "}
                {greeting.title}{" "}
              </h1>
              <p
                className={
                  isDark
                    ? "dark-mode greeting-text-p"
                    : "greeting-text-p subTitle"
                }
              >
                Dr. Omar T. Khan, FACR, is a board certified rheumatologist. He
                has been awarded as a{" "}
                <a
                  href="https://www.atlantamagazine.com/top-doctors/rheumatology/"
                  className="link-style"
                >
                  top doctor in Rheumatology (2023, 2024, 2025,
                </a>{" "}
                <a
                  href="https://www.castleconnolly.com/top-doctors/omar-t-khan-rheumatology-128cc047362"
                  className="link-style"
                >
                  2026)
                </a>{" "}
                by both Atlanta Magazine and Castle Connoly. Dr. Khan has also been honored by the{" "}
                <a
                  href="https://e.givesmart.com/events/Fd2/"
                  className="link-style"
                >
                  National Psoriasis Foundation (2025).
                </a>{" "}
              </p>
              <SocialMedia />
              <div className="button-greeting-div">
                {/* <Button text="Contact Dr. Khan" href="#contact" /> */}
                {greeting.resumeLink && (
                  <Button
                    text="Schedule an appointment"
                    newTab={true}
                    href={greeting.resumeLink}
                  />
                )}
              </div>
            </div>
          </div>
          <div className="greeting-image-div">
            {illustration.animated ? (
              <DrOmarKhanPic />
            ) : (
              <img
                alt="man sitting on table"
                src={require("../../assets/images/manOnTable.svg")}
              ></img>
            )}
          </div>
        </div>
      </div>
    </Fade>
  );
}
